import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const customerStateSyncPlugin = createPlugin({
  id: 'customer-state-sync',
  routes: {
    root: rootRouteRef,
  },
});

export const WebhookTesterPage = customerStateSyncPlugin.provide(
  createRoutableExtension({
    name: 'WebhookTesterPage',
    component: () =>
      import('./components/WebhookTesterPage').then(
        m => m.WebhookTesterComponent,
      ),
    mountPoint: rootRouteRef,
  }),
);
